import { Check } from "lucide-react";

const INK = "#0F1B2D";
const CYAN = "#4F86D6";
const CYAN_DARK = "#0E509C";
const ORANGE = "#E0663F";
const fmt = (n) => `$${Math.round(n).toLocaleString()}`;
import { PLANS, ADDONS, PLATFORM_MONTHLY, INSTALL_FEE, HOURLY } from "./pricing";

export function PlanPicker({ planKey, onPick }) {
  return (
    <>
      <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-3" data-testid="plan-picker">
        {PLANS.map((p) => {
          const monthly = PLATFORM_MONTHLY + p.addons.reduce((s, k) => s + ADDONS.find((a) => a.key === k).monthly, 0);
          const on = planKey === p.key;
          return (
            <button key={p.key} type="button" onClick={() => onPick(p)} data-testid={`plan-${p.key}`} aria-pressed={on}
                    className="text-left rt-card p-5 transition-all hover:-translate-y-0.5"
                    style={{ borderColor: on ? CYAN_DARK : undefined, borderWidth: on ? 2 : undefined, background: on ? `${CYAN}0d` : undefined }}>
              <div className="flex items-center justify-between gap-2">
                <div className="rt-eyebrow">{on ? "Selected" : "Plan"}</div>
                {on && <Check className="h-4 w-4" style={{ color: CYAN_DARK }} />}
              </div>
              <div className="rt-h text-lg mt-1" style={{ color: INK }}>{p.label}</div>
              <div className="text-[12.5px] mt-0.5" style={{ color: INK, opacity: 0.62 }}>{p.sub}</div>
              <div className="rt-h text-2xl mt-3" style={{ color: CYAN_DARK }}>{fmt(monthly)}<span className="text-sm opacity-60">/mo</span></div>
              <div className="text-[11.5px]" style={{ color: INK, opacity: 0.55 }}>+ {fmt(INSTALL_FEE)} install{p.addons.length ? ` · specialist hours $${HOURLY}/hr as used` : ""}</div>
            </button>
          );
        })}
      </div>
      {planKey === "custom" && <div className="mt-2 text-[12px] font-bold" style={{ color: ORANGE }} data-testid="plan-custom">Custom plan — you've tailored beyond the presets.</div>}
    </>
  );
}
